import React, { useContext } from "react";
import { ProviderNetworkType } from "@app/projects/enumerators";
import {
  ClaimsActivityDashboardContext,
  ClaimsActivityProvidersTile,
  ClaimsActivityTopGhostProviderTile,
} from "@app/projects/network-assessment/pci-dashboard/claims-activity";
import { PciDashboardSummaryType } from "@app/projects/network-assessment/pci-dashboard/shared";

export const ClaimsActivityDashboardDefaultView: React.FC<React.PropsWithChildren<unknown>> = () => {
  const claimsActivityContext = useContext(ClaimsActivityDashboardContext);

  return (
    <React.Fragment>
      <div className="row">
        <ClaimsActivityProvidersTile
          data={claimsActivityContext.networkProvidersSummaries}
          loading={claimsActivityContext.networkProvidersSummariesLoading}
          onDashboardDetailsViewClick={claimsActivityContext.onDashboardDetailsViewClick}
          providerType={ProviderNetworkType.Network}
        />
        <ClaimsActivityProvidersTile
          data={claimsActivityContext.prospectProvidersSummaries}
          loading={claimsActivityContext.prospectProvidersSummariesLoading}
          onDashboardDetailsViewClick={claimsActivityContext.onDashboardDetailsViewClick}
          providerType={ProviderNetworkType.Prospect}
        />
        <ClaimsActivityProvidersTile
          data={claimsActivityContext.marketProvidersSummaries}
          loading={claimsActivityContext.marketProvidersSummariesLoading}
          onDashboardDetailsViewClick={claimsActivityContext.onDashboardDetailsViewClick}
          providerType={ProviderNetworkType.Market}
        />
      </div>
      <div className="row">
        <ClaimsActivityTopGhostProviderTile
          getTopGhostWidgetData={claimsActivityContext.getTopGhostWidgetData}
          loading={claimsActivityContext.topGhostProviderCountiesLoading}
          onTopGhostDashboardDetailsViewClick={claimsActivityContext.onTopGhostDashboardDetailsViewClick}
          topGhostProvidersModel={claimsActivityContext.topGhostProviderCountiesModel}
          summaryType={PciDashboardSummaryType.County}
        />
        <ClaimsActivityTopGhostProviderTile
          getTopGhostWidgetData={claimsActivityContext.getTopGhostWidgetData}
          loading={claimsActivityContext.topGhostProviderSpecialtiesLoading}
          onTopGhostDashboardDetailsViewClick={claimsActivityContext.onTopGhostDashboardDetailsViewClick}
          summaryType={PciDashboardSummaryType.Specialty}
          topGhostProvidersModel={claimsActivityContext.topGhostProviderSpecialtiesModel}
        />
      </div>
    </React.Fragment>
  );
}

export default ClaimsActivityDashboardDefaultView;
